import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Platform.css'

const Platform = () => {
  const { t } = useTranslation()

  return (
    <section className='academy-platform'>
      <div className='academy-platform-content'>
        <h2>
          {t('academyPlatform.title')}
          <span>{t('academyPlatform.titleHighlight')}</span>
        </h2>

        <p>{t('academyPlatform.description')}</p>

        <img src={Images.academy.platform} alt='academy platform' className='academy-platform-image' />

        <button
          type='button'
          className='academy-platform-cta'
          onClick={() => window.location.href = 'mailto:hello@tiimapp.com'}
        >
          {t('academyPlatform.button')}
        </button>
      </div>
    </section>
  )
}

export default Platform
